import ExecutiveCommitteePage from "../components/pages/PTAExecutiveCommitte";

export default ExecutiveCommitteePage;